/**
 * Persisted layout sizing for the FileViewer thumbnail strip (the "grey bar"
 * splitter position). The user can drag the divider to condense the strip, and
 * we remember that placement across opens via localStorage.
 */

/** Initial / fallback width of the gallery (secondary) pane, in pixels. */
export const DEFAULT_GALLERY_SIZE = 280

/** Minimum width of the gallery pane, in pixels. Mirrors secondaryMinSize. */
export const MIN_GALLERY_SIZE = 110

/** localStorage key for the persisted gallery pane width. */
export const GALLERY_SIZE_STORAGE_KEY = 'file-viewer-gallery-size'

/**
 * Coerce a persisted/dragged gallery width into a valid pixel value.
 *
 * Falls back to {@link DEFAULT_GALLERY_SIZE} for non-finite input (corrupted
 * localStorage, NaN from a drag), floors at {@link MIN_GALLERY_SIZE}, and caps
 * at `max` when provided (e.g. the available width after a viewport shrank).
 */
export function clampGallerySize(size: unknown, max?: number): number {
  const value = typeof size === 'number' && Number.isFinite(size) ? size : DEFAULT_GALLERY_SIZE

  let clamped = Math.max(MIN_GALLERY_SIZE, value)
  if (typeof max === 'number' && Number.isFinite(max)) {
    clamped = Math.min(clamped, Math.max(MIN_GALLERY_SIZE, max))
  }
  return clamped
}
